"use strict";
exports.__esModule = true;
var Wizard = /** @class */ (function () {
    function Wizard(protocols) {
        this.protocols = protocols;
    }
    Wizard.prototype.findDuplicatesInTemplates = function () {
        var path_ = this.protocols._getPath('wizard/duplicate-menu-id');
        return this.protocols.apiGet(path_);
    };
    Wizard.prototype.fetchPotentialTableInputs = function (templateName) {
        var path_ = this.protocols._getPath('wizard/potential-table-inputs');
        path_ = path_ + "/" + templateName;
        return this.protocols.apiGet(path_);
    };
    Wizard.prototype.predictInputs = function (rangeNamesAsCommaSeparatedText, templatePrefix, author, industry, modelType) {
        var path_ = this.protocols._getPath('wizard/predict-inputs');
        path_ = path_ + "/" + rangeNamesAsCommaSeparatedText + "/" + templatePrefix + "/" + author + "/" + industry + "/" + modelType;
        return this.protocols.apiGet(path_);
    };
    return Wizard;
}());
exports["default"] = Wizard;
//# sourceMappingURL=wizard.js.map


// WEBPACK FOOTER //
// ./app/lib/smartorg-api/wizard.js